import ApiBase from "../api-base";


class AdminApi extends ApiBase {

    constructor() {
        super();
        this.searchCancel = null;
    }


    async systemMessages(page = 1, perPage = 10) {
        return this.handleResponse(async () => {
            let response = await axios.get(`/api/admin/system-messages`, {params : { per_page : perPage, page: page}});
            return response.data;
        });
    }

    async search(term = '') {

        return this.handleResponse(async () => {
            if (this.searchCancel !== null) {
                this.searchCancel.abort();
                this.searchCancel = null;
                return false;
            }

            this.searchCancel = new AbortController();

            let response = await axios.post(`/api/admin/search`, {term: term}, {
                signal: this.searchCancel.signal
            });
            this.searchCancel = null;
            return response.data;
        })

    }

}

export default new AdminApi();
